import { Button, Flex, Heading, Image, Link, Text } from '@/ui';
import { ConsentScopeList } from './ConsentScopeList';
import { type ConsentRequest, CONSENT_ENDPOINT } from './useConsentRequest';

type Props = {
  request: ConsentRequest;
};

export const ConsentCard = ({ request }: Props) => {
  const {
    clientName,
    clientUri,
    logoUri,
    policyUri,
    pendingId,
    scopes,
    userEmail,
  } = request;

  return (
    <>
      {logoUri && (
        <Image
          alt=""
          borderRadius="ah-lg"
          boxSize="48px"
          mx="auto"
          src={logoUri}
        />
      )}

      <Flex direction="column" gap="2">
        <Heading as="h1" fontSize="2xl">
          Connect {clientName}
        </Heading>
        <Text color="ink.soft" fontSize="ah-row">
          {clientName} is asking to use your Agenda Hero account, {userEmail}.
        </Text>
        {clientUri && (
          <Text color="ink.muted" fontSize="ah-status">
            {clientUri}
          </Text>
        )}
      </Flex>

      <Flex direction="column" gap="2">
        <Text color="ink.soft" fontSize="ah-label" textAlign="left">
          IT WILL BE ABLE TO
        </Text>
        <ConsentScopeList scopes={scopes} />
      </Flex>

      {/*
        A real form post, not a fetch. The server answers an approval with a
        redirect back to the app that asked, and only a native submission
        follows that. It also keeps the existing contract exactly: the signed
        cookie is the CSRF defence and pendingId is checked against it.
      */}
      <Flex
        action={CONSENT_ENDPOINT}
        as="form"
        direction="column"
        gap="3"
        method="post"
      >
        <input name="pending_id" type="hidden" value={pendingId} />
        {/*
          Theme defaults rather than the ah- variants: this screen sits in the
          auth flow the user has just come through, and those pages use the
          default button. The ah- set belongs to the app shell.
        */}
        <Button name="decision" type="submit" value="allow">
          Allow access
        </Button>
        <Button name="decision" type="submit" value="deny" variant="outline">
          Cancel
        </Button>
      </Flex>

      {policyUri && (
        <Link
          color="ink.muted"
          fontSize="ah-status"
          href={policyUri}
          isExternal
          rel="noopener noreferrer"
        >
          {clientName} privacy policy
        </Link>
      )}
    </>
  );
};
